import classNames from "classnames";
import { v4 as uuidv4 } from "uuid";
import Icon from "../../Icon";
import PrimeTooltip from "../../PrimeTooltip/PrimeTooltip";

import styles from "../Menu.module.css";

export interface SideBarLinkButtonProps {
  text: string;
  hideText?: boolean;
  icon: string;
  fillColor?: string;
  showTooltip?: boolean;
  truncateText?: boolean;
  dataCy?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const SideBarLinkButton = ({
  text,
  hideText = false,
  icon,
  fillColor,
  showTooltip = false,
  truncateText = false,
  dataCy,
  onClick = undefined,
}: SideBarLinkButtonProps) => {
  const uniqId = `id-${uuidv4()}`;
  return (
    <>
      <button
        id={uniqId}
        type="button"
        data-cy={dataCy}
        data-pr-tooltip={text}
        data-pr-at="right center-4"
        className={styles.sideBarLinkButton}
        onClick={(e) => onClick && onClick(e)}
        aria-label={text || "link"}
      >
        {fillColor ? (
          <div
            style={
              fillColor
                ? {
                    backgroundColor: fillColor || "transparent",
                    width: 24,
                    height: 24,
                    borderRadius: 24,
                  }
                : {}
            }
          />
        ) : (
          <Icon
            name={icon}
            size={24}
            color="Grey-500"
            className={styles.sideBarLinkIcon}
          />
        )}
        {!hideText ? (
          <span
            className={classNames({
              [styles.sideBarLinkButtonText]: true,
              [styles.truncateText]: truncateText,
            })}
          >
            {text}
          </span>
        ) : null}
      </button>
      {(showTooltip || truncateText) && (
        <PrimeTooltip target={`#${uniqId}`} position="right" theme="dark" />
      )}
    </>
  );
};
